var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAssessment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0s{opacity:0.3;fill:currentColor;}\n\t.st1s{opacity:0.6;fill:currentColor;}\n\t.st2s{fill:currentColor;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0s",
    points: "8.5,7.7 2,5.2 8.5,2.6 14.9,5.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1s",
    points: "8.5,7.7 8.5,45.4 8.4,45.4 2,42.9 2,5.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2s",
    points: "8.5,45.4 14.9,42.9 14.9,5.2 8.5,7.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0s",
    points: "24.2,26 17.7,23.5 24.1,20.9 30.6,23.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1s",
    points: "24.1,26 24.1,45.4 24,45.4 17.7,42.9 17.7,23.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2s",
    points: "24.1,45.4 30.6,42.9 30.6,23.5 24.2,26  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0s",
    points: "39.6,16.9 33.1,14.3 39.5,11.8 46,14.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1s",
    points: "39.5,16.9 39.5,45.4 39.5,45.4 33.1,42.9 33.1,14.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2s",
    points: "39.5,45.4 46,42.9 46,14.3 39.6,16.9  "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessment);
export default __webpack_public_path__ + "static/media/assessment.4ca864f875657a677aa7d6dd2f6aab94.svg";
export { ForwardRef as ReactComponent };